import { render, staticRenderFns } from "./spinner.vue?vue&type=template&id=6cbdb8da&"
var script = {}
import style0 from "./spinner.vue?vue&type=style&index=0&id=6cbdb8da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports